// Replacement for input[type=number] to allow comma in all browsers
angular.
module("dx.webapp.validation").
directive("dxDecimalNumber", function decimalNumberDirective() {
	"use strict";

	// Regex from http://stackoverflow.com/a/39399503/959140
	// https://regex101.com/r/uJ0bS8/1
	var decimalFormat = /^-?(0|[1-9]\d*)(\.\d+)?$/;

	return {
		restrict: "A",
		require: "ngModel",
		link: link,
	};

	function link($scope, $element, $attrs, $ngModel) {
		var max = null;
		var min = null;

		$attrs.$observe("max", function maxObserve(newMax) {
			max = parseFloat(newMax);
		});

		$attrs.$observe("min", function minObserve(newMin) {
			min = parseFloat(newMin);
		});

		function decimalParser(val) {
			$ngModel.$setValidity("required", true);
			$ngModel.$setValidity("validNumber", true);
			$ngModel.$setValidity("max", true);
			$ngModel.$setValidity("min", true);

			if (val === "") {
				$ngModel.$setValidity("required", false);
				return null;
			}

			var cleanedVal = val;

			// Clean up of the number to allow space thousand separator
			// and comma as decimal separator
			if (typeof cleanedVal === "string") {
				cleanedVal = cleanedVal.replace(/ /g, "");
				cleanedVal = cleanedVal.replace(/,/g, ".");
			}

			if (!cleanedVal) {
				$ngModel.$setValidity("validNumber", false);
				return $ngModel.$modelValue;
			}

			// Validate the formatting of the number
			if (!decimalFormat.test(cleanedVal)) {
				$ngModel.$setValidity("validNumber", false);
				return $ngModel.$modelValue;
			}

			var num = parseFloat(cleanedVal);

			// Sanity check that we actually can extract a float
			if (isNaN(num)) {
				$ngModel.$setValidity("validNumber", false);
				return $ngModel.$modelValue;
			}

			// Need more explicit checking of max since it can be 0 which it falsy
			var isMaxSet = !!max || max === 0;
			if (isMaxSet && num > max) {
				$ngModel.$setValidity("max", false);
				return $ngModel.$modelValue;
			}

			// Need more explicit checking of min since it can be 0 which it falsy
			var isMinSet = !!min || min === 0;
			if (isMinSet && num < min) {
				$ngModel.$setValidity("min", false);
				return $ngModel.$modelValue;
			}

			// According to the documentation, undefined should be returned if a parse
			// error occurs, otherwise the value should be returned.
			// https://code.angularjs.org/1.5.10/docs/api/ng/type/ngModel.NgModelController
			return num; // eslint-disable-line consistent-return
		}

		if ($ngModel) {
			$ngModel.$parsers.unshift(decimalParser);
		}
	}
});
